<template>
  <div class="panel">
    <!-- 抵扣 -->
    <div class="divider">{{ $t('444') }}</div>
    <!-- 夫妻抵扣 -->
    <el-form-item prop="tax_deduction_7">
      <template slot="label">
        <span>{{ $t('1458') }}</span>
        <el-tooltip class="item" effect="dark" :content="$t('payroll_deduction_error_11')" placement="top-start">
          <img class="icon" src="@/assets/img/icon_doubt.png" alt="" />
        </el-tooltip>
      </template>
      <el-input
        v-enterNumberMax="120000"
        :disabled="show"
        v-model="staffInfo.tax_deduction_7"
        v-enterNumberPoint2
        placeholder="0.00"
      ></el-input>
    </el-form-item>
    <!-- 子女抵扣 -->
    <el-form-item prop="tax_deduction_8">
      <template slot="label">
        <span>{{ $t('1459') }}</span>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$t('payroll_deduction_error_9', { key: '90,000', x: currency })"
          placement="top-start"
        >
          <img class="icon" src="@/assets/img/icon_doubt.png" alt="" />
        </el-tooltip>
      </template>
      <el-input
        v-enterNumberMax="90000"
        :disabled="show"
        v-model.number="staffInfo.tax_deduction_8"
        placeholder="0.00"
      ></el-input>
    </el-form-item>
    <!-- 父母抵扣 -->
    <el-form-item prop="tax_deduction_9">
      <template slot="label">
        <span>{{ $t('1460') }}</span>
        <el-tooltip class="item" effect="dark" :content="$t('payroll_deduction_error_12')" placement="top-start">
          <img class="icon" src="@/assets/img/icon_doubt.png" alt="" />
        </el-tooltip>
      </template>
      <el-input
        v-enterNumberMax="120000"
        :disabled="show"
        v-model="staffInfo.tax_deduction_9"
        v-enterNumberPoint2
        placeholder="0.00"
      ></el-input>
    </el-form-item>
    <!-- 人寿保险 -->
    <el-form-item prop="tax_deduction_10">
      <template slot="label">
        <span>{{ $t('1461') }}</span>
        <el-tooltip
          class="item"
          effect="dark"
          :content="`${$t('payroll_deduction_error_9', { key: '100,000', x: currency })};${$t(
            'payroll_deduction_error_10',
            { x: currency }
          )}`"
          placement="top-start"
        >
          <img class="icon" src="@/assets/img/icon_doubt.png" alt="" />
        </el-tooltip>
      </template>
      <el-input
        v-enterNumberMax="100000"
        :disabled="show"
        v-model.number="staffInfo.tax_deduction_10"
        placeholder="0.00"
        @blur="blurDeduction10"
      ></el-input>
    </el-form-item>
    <!-- 医疗保险 -->
    <el-form-item prop="tax_deduction_11">
      <template slot="label">
        <span>{{ $t('1462') }}</span>
        <el-tooltip
          class="item"
          effect="dark"
          :content="`${$t('payroll_deduction_error_9', { key: '25,000', x: currency })};${$t(
            'payroll_deduction_error_10',
            { x: currency }
          )}`"
          placement="top-start"
        >
          <img class="icon" src="@/assets/img/icon_doubt.png" alt="" />
        </el-tooltip>
      </template>
      <el-input
        v-enterNumberMax="25000"
        :disabled="show"
        v-model.number="staffInfo.tax_deduction_11"
        placeholder="0.00"
        @blur="blurDeduction11"
      ></el-input>
    </el-form-item>
    <!-- 父母医疗保险 -->
    <el-form-item prop="tax_deduction_12">
      <template slot="label">
        <span>{{ $t('1464') }}</span>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$t('payroll_deduction_error_9', { key: '15,000', x: currency })"
          placement="top-start"
        >
          <img class="icon" src="@/assets/img/icon_doubt.png" alt="" />
        </el-tooltip>
      </template>
      <el-input
        v-enterNumberMax="15000"
        :disabled="show"
        v-model.number="staffInfo.tax_deduction_12"
        placeholder="0.00"
      ></el-input>
    </el-form-item>
    <!-- 超级储蓄基金投资 -->
    <el-form-item prop="tax_deduction_13">
      <template slot="label">
        <span>{{ $t('1465') }}</span>
        <el-tooltip class="item" effect="dark" :content="$t('payroll_deduction_error_14')" placement="top-start">
          <img class="icon" src="@/assets/img/icon_doubt.png" alt="" />
        </el-tooltip>
      </template>
      <el-input
        v-enterNumberMax="200000"
        :disabled="show"
        v-model.number="staffInfo.tax_deduction_13"
        placeholder="0.00"
        @blur="blurDeduction13"
      ></el-input>
    </el-form-item>
    <!-- 共同基金 -->
    <el-form-item prop="tax_deduction_14">
      <template slot="label">
        <span>{{ $t('1466') }}</span>
        <el-tooltip class="item" effect="dark" :content="$t('payroll_deduction_error_15')" placement="top-start">
          <img class="icon" src="@/assets/img/icon_doubt.png" alt="" />
        </el-tooltip>
      </template>
      <el-input
        v-enterNumberMax="500000"
        :disabled="show"
        v-model.number="staffInfo.tax_deduction_14"
        placeholder="0.00"
        @blur="blurDeduction14"
      ></el-input>
    </el-form-item>
    <!-- 住房贷款利息 -->
    <el-form-item prop="tax_deduction_15">
      <template slot="label">
        <span>{{ $t('1467') }}</span>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$t('payroll_deduction_error_9', { key: '100,000', x: currency })"
          placement="top-start"
        >
          <img class="icon" src="@/assets/img/icon_doubt.png" alt="" />
        </el-tooltip>
      </template>
      <el-input
        v-enterNumberMax="100000"
        :disabled="show"
        v-model.number="staffInfo.tax_deduction_15"
        placeholder="0.00"
      ></el-input>
    </el-form-item>
    <!-- 慈善捐款 -->
    <el-form-item>
      <template slot="label">
        <span>{{ $t('1468') }}</span>
        <el-tooltip class="item" effect="dark" :content="$t('payroll_deduction_error_13')" placement="top-start">
          <img class="icon" src="@/assets/img/icon_doubt.png" alt="" />
        </el-tooltip>
      </template>
      <el-input :disabled="show" v-model="staffInfo.tax_deduction_16" v-enterNumberPoint2 placeholder="0.00"></el-input>
    </el-form-item>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'tax-info',
  components: {},
  props: {
    staffInfo: {
      type: Object,
      default: () => {}
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 货币
    ...mapState({
      currency: state => state.user.company_info.currency
    })
  },
  mounted() {},
  methods: {
    blurDeduction10() {
      this.$emit('blurDeduction10', this.staffInfo.tax_deduction_10)
    },
    blurDeduction11() {
      this.$emit('blurDeduction11', this.staffInfo.tax_deduction_11)
    },
    blurDeduction13() {
      this.$emit('blurDeduction13', this.staffInfo.tax_deduction_13)
    },
    blurDeduction14() {
      this.$emit('blurDeduction14', this.staffInfo.tax_deduction_14)
    }
  }
}
</script>
<style lang="scss" scoped>
.panel {
  overflow: hidden;
}
.icon {
  width: 16px;
  vertical-align: middle;
  margin-top: -4px;
  margin-left: 5px;
}
.divider {
  color: #262626;
  font-size: 14px;
  font-weight: 500;
  line-height: 30px;
}
</style>
